var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "saas_long_image_inner_padding" },
    [
      _vm.moduleList.length < 1 && !_vm.value.unique_id
        ? _c("empty", { attrs: { value: _vm.value } })
        : _c(
            "div",
            {
              staticClass: "saas_long_image_inner",
              style: {
                backgroundColor: _vm.value.config.bg_color || "#ffffff",
              },
            },
            [
              _vm.value.config.type === "1"
                ? _c("div", { staticClass: "header" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.value.config.name,
                            expression: "value.config.name",
                          },
                        ],
                        staticClass: "title",
                      },
                      [_vm._v(" " + _vm._s(_vm.value.config.name) + " ")]
                    ),
                    _c("i", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.value.config.data_source_type !== 2,
                          expression: "value.config.data_source_type !== 2",
                        },
                      ],
                      staticClass: "el-icon el-icon-arrow-right",
                    }),
                  ])
                : _vm._e(),
              _vm.value.config.type === "2"
                ? _c("el-image", {
                    staticStyle: { width: "100%" },
                    attrs: { src: _vm.value.config.header_image },
                  })
                : _vm._e(),
              _c(
                "div",
                { staticClass: "content" },
                _vm._l(_vm.moduleList, function (item) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "activity" },
                    [_c("el-image", { attrs: { src: item.swipe_image } })],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }